import { BracketTeam } from "@portal-frontend-ssr/blast-api";
import classNames from "classnames";
import { useContext, useMemo } from "react";
import { generateTeamLogoSrc } from "~/shared/helpers/url/generateTeamLogoSrc";
import { SwissTournamentContext } from "../../../../SwissBracketComponent";

interface GroupResultProps {
  title: string;
  numberOfTeams: number;
  teams?: BracketTeam[];
  state: "success" | "fail" | "playoffs";
}

const GroupResult = ({ title, numberOfTeams, teams, state }: GroupResultProps) => {
  const swissContext = useContext(SwissTournamentContext);

  const isHighlighted = useMemo(() => {
    return swissContext?.hoveredTeamUuid && teams?.some((team) => team.uuid === swissContext?.hoveredTeamUuid);
  }, [swissContext?.hoveredTeamUuid, teams]);

  const getTeams = () => {
    const teamsArray = [];
    for (let i = 0; i < numberOfTeams; i++) {
      if (teams && teams[i]) {
        teamsArray.push(
          <img
            className="relative h-auto max-h-5 w-5 object-scale-down align-middle"
            src={generateTeamLogoSrc({ id: teams[i].uuid, height: 56 })}
            alt={teams[i].name}
            key={`logo-${i}`}
          />,
        );
        continue;
      } else {
        teamsArray.push(<span key={`span-${i}`}>?</span>);
      }
    }
    return teamsArray;
  };
  return (
    <div
      className={classNames("flex w-full flex-col items-center", {
        "opacity-50": !isHighlighted && swissContext?.hoveredTeamUuid,
      })}
    >
      <span
        className={classNames("px-2 pb-1 pt-0.5 font-style-label-l5", {
          "text-success": state === "success",
          "text-error": state === "fail",
          "text-neutral": state === "playoffs",
        })}
      >
        {title}
      </span>
      <div
        className={classNames(
          "flex h-9 w-full items-center justify-center gap-6 rounded-small border bg-background-100 font-style-label-l3",
          {
            "border-error": state === "fail",
            "border-success": isHighlighted,
            "border-transparent": !isHighlighted,
          },
        )}
      >
        {getTeams()}
      </div>
    </div>
  );
};

export { GroupResult };
